var _a, _b, _c, _d, _e, _f, _g;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions as ErrorActions } from '@/store/enums/ErrorHandleEnum';
import { Actions, Mutations } from '@/store/enums/hrgs/master/schema/MasterSchemaPostEnums';
import ApiService from '@/core/services/ApiService';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    getMasterSchemaAnswerTypeList: `${API_URL}/api/answertypes`,
    postMasterData: `${API_URL}/api/schemes`
};
const errorFormDialog = (responseAxios, self, pageName) => {
    self.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
        page: pageName,
        type: 'formError',
        name: 'masterQuestionCodeFilterValidation',
        message: [`${responseAxios.statusCode} - ${responseAxios.message}`],
        status: true
    });
};
let MasterSchemaPostModule = class MasterSchemaPostModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.pageName = 'masterSchemaPostPage';
        this.masterSchemaFormInput = {
            schemaId: '',
            code: '',
            title: '',
            answerTypeIds: []
        };
        this.initMasterSchemaFormInput = Object.assign({}, this.masterSchemaFormInput);
        this.answerTypeOptions = [];
    }
    // *GETTERS
    get getMasterSchemaAnswerTypeOptionsList() {
        return this.answerTypeOptions;
    }
    get getMasterSchemaFormInput() {
        return this.masterSchemaFormInput;
    }
    // *MUTATIONS
    [_a = Mutations.SET_ANSWER_TYPE_OPTIONS](payload) {
        const formattedOptions = payload.map((element) => {
            return {
                value: element.id,
                label: element.name
            };
        });
        this.answerTypeOptions = formattedOptions;
    }
    [_b = Mutations.SET_MASTER_SCHEMA_LIST_DETAIL](payload) {
        const formattedOptions = payload.answerTypes.map((element) => {
            return element.id;
        });
        this.masterSchemaFormInput.schemaId = payload.id;
        this.masterSchemaFormInput.code = payload.code;
        this.masterSchemaFormInput.title = payload.title;
        this.masterSchemaFormInput.answerTypeIds = formattedOptions;
    }
    // clear form input
    [_c = Mutations.CLEAR_FORM_INPUT]() {
        this.masterSchemaFormInput = Object.assign({}, this.initMasterSchemaFormInput);
    }
    // *start: ACTION
    // *get answerTypes
    [_d = Actions.GET_ANSWER_TYPE_OPTIONS](payload) {
        const url = `${API_URLS.getMasterSchemaAnswerTypeList}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(url + `/${payload.employeeID}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content;
                this.context.commit(Mutations.SET_ANSWER_TYPE_OPTIONS, data);
                resolve();
            })
                .catch((error) => {
                this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                    page: payload.pageName,
                    type: 'unhandledError',
                    name: `get-answer-type-options`,
                    message: error
                });
                reject();
            });
        });
    }
    [_e = Actions.GET_MASTER_SCHEMA_LIST_DETAIL](payload) {
        const url = `${API_URLS.postMasterData}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(url +
                `/${payload.employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content;
                this.context.commit(Mutations.SET_MASTER_SCHEMA_LIST_DETAIL, data);
                resolve();
            })
                .catch((error) => {
                this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                    page: payload.pageName,
                    type: 'unhandledError',
                    name: `get-master-schema-list-detail`,
                    message: error
                });
                reject();
            });
        });
    }
    // *post data
    [_f = Actions.POST_DATA](payload) {
        const employeeID = payload.employeeID;
        const pageName = payload.pageName;
        const params = {
            ver: 'v1'
        };
        const masterSchemaData = {
            code: this.masterSchemaFormInput.code,
            title: this.masterSchemaFormInput.title,
            answerTypeIds: this.masterSchemaFormInput.answerTypeIds
        };
        return new Promise((resolve, reject) => {
            ApiService.post(API_URLS.postMasterData +
                `/${employeeID}?${new URLSearchParams(params).toString()}`, masterSchemaData)
                .then((res) => {
                if (res.data.result.isError) {
                    this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                        page: pageName,
                        type: 'formError',
                        name: 'masterSchemaPostFormValidation',
                        message: [res.data.result.message],
                        status: true
                    });
                }
                else if (res.data.result.content.messageName) {
                    this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                        page: pageName,
                        type: 'formError',
                        name: 'masterSchemaPostFormValidation',
                        message: [res.data.result.content.messageName],
                        status: true
                    });
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                    page: pageName,
                    type: 'formError',
                    name: 'masterSchemaPostFormValidation',
                    message: [_response],
                    status: true
                });
                errorFormDialog(_response, this, pageName);
                reject();
            });
        });
    }
    // *update data
    [_g = Actions.UPDATE_DATA](payload) {
        const employeeID = payload.employeeID;
        const pageName = payload.pageName;
        const schemaId = this.masterSchemaFormInput.schemaId;
        const params = {
            ver: 'v1'
        };
        const masterSchemaData = {
            code: this.masterSchemaFormInput.code,
            title: this.masterSchemaFormInput.title,
            answerTypeIds: this.masterSchemaFormInput.answerTypeIds
        };
        return new Promise((resolve, reject) => {
            ApiService.put(API_URLS.postMasterData +
                `/${employeeID}/${schemaId}?${new URLSearchParams(params).toString()}`, masterSchemaData)
                .then((res) => {
                if (res.data.result.isError) {
                    this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                        page: pageName,
                        type: 'formError',
                        name: 'masterSchemaPostFormValidation',
                        message: [res.data.result.message],
                        status: true
                    });
                }
                else if (res.data.result.content.messageName) {
                    this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                        page: pageName,
                        type: 'formError',
                        name: 'masterSchemaPostFormValidation',
                        message: [res.data.result.content.messageName],
                        status: true
                    });
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                this.context.dispatch(ErrorActions.UPDATE_ERROR_TO_PAGE, {
                    page: pageName,
                    type: 'formError',
                    name: 'masterSchemaPostFormValidation',
                    message: [_response],
                    status: true
                });
                errorFormDialog(_response, this, pageName);
                reject();
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaPostModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaPostModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterSchemaPostModule.prototype, _c, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaPostModule.prototype, _d, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaPostModule.prototype, _e, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaPostModule.prototype, _f, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterSchemaPostModule.prototype, _g, null);
MasterSchemaPostModule = __decorate([
    Module
], MasterSchemaPostModule);
export default MasterSchemaPostModule;
